import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Supplier, SupplierCreate, SupplierFilter } from '../data/supplier';

export function createSupplierService(client: AxiosInstance) {
  return createCrudService<Supplier, SupplierCreate, SupplierFilter>(
    client,
    '/Supplier',
    'supplierId',
  );
}

export type SupplierService = CrudService<Supplier, SupplierCreate, SupplierFilter>;
